export const COMMENTS_PER_PAGE = 20;
export const POSTS_PER_PAGE = 20;
export const LIKES_PER_PAGE = 20;
export const MEMBERS_PER_PAGE = 18;



// WEBPACK FOOTER //
// ./app/constants/pagination.js